var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { hideMenuProvider } from '../../utilities/picker.tools';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import './inner-semi-annual-picker/inner-semi-annual-picker';
import { getCurrentYear, getMonthsForSemiAnnual } from './semi-annual-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-semi-annual-picker` is a web component designed for selecting semi-annual periods.
 * It allows users to easily choose from two semi-annual options (e.g., first half and second half of a year).
 * The component is particularly useful in scenarios such as financial reporting, academic calendars,
 * or any context where tracking semi-annual periods is necessary.
 *
 * The component features customizable attributes, including options for placeholders,
 * currently selected year and semi-annual period, hints, and error handling.
 *
 * ### Attributes
 * - `placeholder`: The placeholder text for the input field. Defaults to `'sds.semi-annual_picker.placeholder'`.
 * - `selected-year`: The currently selected year for the semi-annual period. Reflects the selected year as a number.
 *   Defaults to the current year.
 * - `selected-semi-annual`: The currently selected semi-annual period, represented as a number or undefined.
 * - `hint`: A hint to provide context for the selection.
 * - `disabled`: A boolean indicating if the picker is disabled. Defaults to `false`.
 * - `invalid`: A boolean indicating if the selection is invalid. Defaults to `false`.
 * - `error-message`: The error message to display if validation fails.
 *
 * @tag sds-semi-annual-picker
 */
let SdsSemiAnnualPicker = (() => {
    var _SdsSemiAnnualPicker_placeholder_accessor_storage, _SdsSemiAnnualPicker_selectedYear_accessor_storage, _SdsSemiAnnualPicker_selectedSemiAnnual_accessor_storage, _SdsSemiAnnualPicker_hint_accessor_storage, _SdsSemiAnnualPicker_disabled_accessor_storage, _SdsSemiAnnualPicker_invalid_accessor_storage, _SdsSemiAnnualPicker_errorMessage_accessor_storage, _SdsSemiAnnualPicker__contextMenu_accessor_storage, _SdsSemiAnnualPicker__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-semi-annual-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _selectedYear_decorators;
    let _selectedYear_initializers = [];
    let _selectedYear_extraInitializers = [];
    let _selectedSemiAnnual_decorators;
    let _selectedSemiAnnual_initializers = [];
    let _selectedSemiAnnual_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsSemiAnnualPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSemiAnnualPicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.semi-annual_picker.placeholder'));
            _SdsSemiAnnualPicker_selectedYear_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _selectedYear_initializers, getCurrentYear())));
            _SdsSemiAnnualPicker_selectedSemiAnnual_accessor_storage.set(this, (__runInitializers(this, _selectedYear_extraInitializers), __runInitializers(this, _selectedSemiAnnual_initializers, void 0)));
            _SdsSemiAnnualPicker_hint_accessor_storage.set(this, (__runInitializers(this, _selectedSemiAnnual_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsSemiAnnualPicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsSemiAnnualPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsSemiAnnualPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsSemiAnnualPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsSemiAnnualPicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this.hideMenu = (__runInitializers(this, __inputDate_extraInitializers), hideMenuProvider(this));
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                }
            };
            this.semiAnnualSelectedHandler = (e) => {
                if (e.detail.close) {
                    this.hideContextMenu();
                }
                this.selectedSemiAnnual = e.detail.selectedSemiAnnual;
                this.selectedYear = e.detail.selectedYear;
                this.dispatchChanged();
            };
            this.keypressHandler = (e) => {
                switch (e.key) {
                    case 'ArrowLeft':
                        e.currentTarget.navigateBack();
                        break;
                    case 'ArrowRight':
                        e.currentTarget.navigateForward();
                        break;
                }
            };
            this.handleCleared = () => {
                this.selectedSemiAnnual = undefined;
                this.selectedYear = getCurrentYear();
            };
        }
        /**
         * Sets the placeholder text for the semi-annual picker input, providing a hint to users when no selection is made.
         * This attribute helps guide users to understand the expected input or purpose of the semi-annual selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the semi-annual picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Represents the currently selected year for the semi-annual period.
         * Reflects the selected year as a number and defaults to the current year.
         * This attribute is essential for determining the context of the semi-annual selection.
         *
         * @attr {number} selected-year - Currently selected year for the semi-annual picker.
         */
        get selectedYear() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_selectedYear_accessor_storage, "f"); }
        set selectedYear(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_selectedYear_accessor_storage, value, "f"); }
        /**
         * Indicates the currently selected semi-annual period.
         * This attribute helps in managing the state of the semi-annual picker, allowing the user to know
         * which period is currently selected or undefined if none is selected.
         *
         * @attr {number} selected-semi-annual - Currently selected semi-annual period.
         */
        get selectedSemiAnnual() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_selectedSemiAnnual_accessor_storage, "f"); }
        set selectedSemiAnnual(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_selectedSemiAnnual_accessor_storage, value, "f"); }
        /**
         * Provides a hint for this semi-annual picker, enhancing user understanding of its purpose.
         * This attribute can display additional context or instructions relevant to the semi-annual selection.
         *
         * @attr {string} hint - Hint text for the semi-annual picker.
         */
        get hint() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_hint_accessor_storage, value, "f"); }
        /**
         * Indicates whether the semi-annual picker is disabled, preventing user interaction.
         * This attribute is useful for managing the picker state based on application logic or user permissions.
         *
         * @attr {boolean} disabled - True if this semi-annual picker is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_disabled_accessor_storage, value, "f"); }
        /**
         * Specifies if this semi-annual picker is invalid, typically used for validation feedback.
         * This attribute can help in managing form states, indicating to users that their selection needs attention.
         *
         * @attr {boolean} invalid - True if this semi-annual picker is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_invalid_accessor_storage, value, "f"); }
        /**
         * Contains the error message displayed when the semi-annual picker is invalid.
         * This attribute is crucial for informing users about validation issues, guiding them towards a resolution.
         *
         * @attr {string} error-message - Error message for the semi-annual picker in case of validation error.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker_errorMessage_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsSemiAnnualPicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsSemiAnnualPicker__inputDate_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                value="${this.getInputValue()}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu>
                <sds-inner-semi-annual-picker
                    tabindex="0"
                    @sds.inner-semi-annual-picker.changed="${this.semiAnnualSelectedHandler}"
                    selected-semi-annual="${this.selectedSemiAnnual}"
                    selected-year="${this.selectedYear}"
                    @keydown="${this.keypressHandler}"
                >
                </sds-inner-semi-annual-picker>
            </sds-context-menu>
        `;
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
        }
        resetPage() {
            var _a;
            (_a = this._sdsInnerSemiAnnualPicker) === null || _a === void 0 ? void 0 : _a.updateNavigationState('SelectSemiAnnual');
            this.updatePageIndex();
        }
        getInputValue() {
            if (this.selectedSemiAnnual) {
                return `S/A ${this.selectedSemiAnnual}, ${this.selectedYear} (${getMonthsForSemiAnnual(this.selectedSemiAnnual)})`;
            }
            else {
                return '';
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerSemiAnnualPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-inner-semi-annual-picker');
            if (sdsInnerSemiAnnualPicker) {
                this._sdsInnerSemiAnnualPicker = sdsInnerSemiAnnualPicker;
            }
        }
        updatePageIndex() {
            var _a, _b;
            if (this.selectedSemiAnnual) {
                (_a = this._sdsInnerSemiAnnualPicker) === null || _a === void 0 ? void 0 : _a.updatePageIndex(this.selectedYear);
            }
            else {
                (_b = this._sdsInnerSemiAnnualPicker) === null || _b === void 0 ? void 0 : _b.updatePageIndex(getCurrentYear());
            }
        }
        dispatchChanged() {
            this.dispatchEvent(new CustomEvent(SdsSemiAnnualPicker.SEMI_ANNUAL_PICKER_CHANGED, {
                detail: {
                    selectedSemiAnnual: this.selectedSemiAnnual,
                    selectedYear: this.selectedYear,
                },
            }));
        }
    };
    _SdsSemiAnnualPicker_placeholder_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_selectedYear_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_selectedSemiAnnual_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_hint_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_disabled_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_invalid_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsSemiAnnualPicker__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSemiAnnualPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _selectedYear_decorators = [property({ type: Number, attribute: 'selected-year', reflect: true })];
        _selectedSemiAnnual_decorators = [property({ type: Number, attribute: 'selected-semi-annual', reflect: true })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _selectedYear_decorators, { kind: "accessor", name: "selectedYear", static: false, private: false, access: { has: obj => "selectedYear" in obj, get: obj => obj.selectedYear, set: (obj, value) => { obj.selectedYear = value; } }, metadata: _metadata }, _selectedYear_initializers, _selectedYear_extraInitializers);
        __esDecorate(_classThis, null, _selectedSemiAnnual_decorators, { kind: "accessor", name: "selectedSemiAnnual", static: false, private: false, access: { has: obj => "selectedSemiAnnual" in obj, get: obj => obj.selectedSemiAnnual, set: (obj, value) => { obj.selectedSemiAnnual = value; } }, metadata: _metadata }, _selectedSemiAnnual_initializers, _selectedSemiAnnual_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSemiAnnualPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.SEMI_ANNUAL_PICKER_CHANGED = 'sds.semi-annual-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSemiAnnualPicker = _classThis;
})();
export { SdsSemiAnnualPicker };
